<template>
    <div class="icon-Chevron-Left"></div>
</template>